'use strict';

import Form from '_core_ext/components/forms/Form';

export default class RegisterForm extends Form {
    init() {
        super.init();
        this.disableEmail();
        this.event('click', '.js-submit', this.submit);
        this.event('change', '.js-contact-preference-news', this.toggleSubscriptionCheckbox);
        this.event('change', '.js-contact-preference-whiskey-news', this.toggleNewsCheckbox);
        this.event('keydown', '.js-confirm-password', this.confirmPasswordClearError);
        this.event('change', 'input[type="checkbox"]', this.toggleCheckboxAriaAttr);
    }

    toggleCheckboxAriaAttr(element) {
        const isChecked = element.checked;
        element.setAttribute('aria-checked', isChecked);
    }

    submit(element, event) {
        if (!this.isChildsValid()) {
            event.preventDefault();
            return;
        }
    }

    disableEmail() {
        if (this.$el.find('.js-edit-profile').length > 0) {
            this.$el.find('.js-email input').prop('readonly', true);
        }
    }

    toggleMobileFieldMandatoryState() {
        this.changeMobileFieldRequiredState();
        this.$el.find('.js-phone').toggleClass('form__row-mandatory');
    }

    toggleNewsCheckbox(event) {
        let newsCheckbox = this.$el.find('.js-contact-preference-news').find('.js-input_field')[0];

        if (event.querySelector('input').checked && newsCheckbox && !newsCheckbox.checked) {
            newsCheckbox.click();
        }
    }

    toggleSubscriptionCheckbox(event) {
        let subscriptionCheckbox = this.$el.find('.js-contact-preference-whiskey-news').find('.js-input_field')[0];

        if (!event.querySelector('input').checked && subscriptionCheckbox && subscriptionCheckbox.checked) {
            subscriptionCheckbox.click();
        }
    }

    changeMobileFieldRequiredState(state) {
        var mobileFieldID = $('.js-phone').find('input').prop('id');

        this.getById(mobileFieldID, function (field) {
            // if there is no state specified - toggle state
            field.config.required = typeof state === 'boolean' ? state : !field.config.required;
            field.validate();
        });
    }

    _findElementWithFormFieldId(formFieldId) {
        let found = null;

        this.eachChild(item => {
            if (item.id && ~item.id.indexOf(formFieldId)) {
                found = item;
            }
        });
        return found;
    }

    confirmPasswordClearError(element) {
        if ($(element).next('.form__error')) {
            $(element).next('.form__error').remove();
        }
    }
}
module.exports = RegisterForm;
